var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2.7,
    width: 17.7,
    height: 18,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "dashboard_customize_black_24dp"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1915",
    d: "M0,0h24v24H0V0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20007"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20007-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4494",
    d: "M6.8,2.7c2,0,3.7,1.6,3.6,3.7,0,2-1.6,3.7-3.7,3.6-2,0-3.6-1.6-3.7-3.7,0-2,1.6-3.7,3.7-3.7s0,0,0,0M4.7,11.8h4.2c.9,0,1.7.8,1.7,1.7h0v5.5c0,.9-.8,1.7-1.7,1.7h-4.2c-.9,0-1.7-.8-1.7-1.7h0v-5.5c0-.9.8-1.7,1.7-1.7M14.8,2.7h4.3c.9,0,1.6.7,1.6,1.6v4c0,.9-.7,1.6-1.6,1.6h-4.3c-.9,0-1.6-.7-1.6-1.6v-4c0-.9.7-1.6,1.6-1.6M20.7,18.4v-4.1c0-.1,0-.2-.1-.2l-3.5-2c0,0-.2,0-.3,0l-3.5,2c0,0-.1.1-.1.2v4.1c0,.1,0,.2.1.2l3.5,2c0,0,.2,0,.3,0l3.5-2c0,0,.1-.1.1-.2",
    fill: "#000"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.3db75d33f4848eae7c9a46ab8c103047.svg";
export { ForwardRef as ReactComponent };